import React from 'react';
export function DeckScreens() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-23">
      <div className="max-w-7xl mx-auto" data-id="element-24">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-25">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight mb-6" data-id="element-26">
            Glass Deck Railing, Window Screens & Door Screens
          </h2>
          <p className="text-lg text-slate-600" data-id="element-27">
            Kosin’s Glass can help with more than windows. The team supplies
            custom glass panels for deck railings and can repair or replace
            damaged window screens and door screens.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-28">
          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200 flex flex-col h-full" data-id="element-29">
            <h3 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-30">
              Glass Deck Railing Panels
            </h3>
            <p className="text-slate-600 text-lg mb-8 flex-grow" data-id="element-31">
              Custom glass panels for deck railings help homeowners, builders
              and contractors create modern outdoor spaces with open views,
              durable tempered glass and a clean finished look.
            </p>
            <div data-id="element-32">
              <a href="/deckglass.html" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-33">
                Learn About Glass Deck Railing
              </a>
            </div>
          </div>

          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200 flex flex-col h-full" data-id="element-34">
            <h3 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-35">
              Window & Door Screens
            </h3>
            <p className="text-slate-600 text-lg mb-8 flex-grow" data-id="element-36">
              Damaged screens can be repaired or replaced by replacing the
              screen material, helping improve airflow and everyday use.
            </p>
            <div data-id="element-37">
              <a href="#estimate-form" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-38">
                Ask About Screen Repair
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}